import urlResolver from 'admin/utils/URLResolver';
import useSWRImmutable from 'swr/immutable';

// `courseId` picks a course added to the class instead of its primary course.
export const useClassAssemblage = (classId, courseId) => {
  const url = urlResolver.reverse('api:course-assemblage', { classId });
  const { data: assemblage, error } = useSWRImmutable(
    courseId ? `${url}?course=${courseId}` : url
  );

  if (error) {
    console.error('There was an error loading the course assemblage', error);
  }

  return {
    data: assemblage,
    error,
    loading: !assemblage && !error,
  };
};
